import { render, staticRenderFns } from "./VulnerablePackagesChart.vue?vue&type=template&id=249ae9fc&"
import script from "./VulnerablePackagesChart.vue?vue&type=script&lang=js&"
export * from "./VulnerablePackagesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports